const dictionary = {
    pt: {
      messages: {
        cpf: () => 'CPF inválido',
        required: () => `Informe o CPF`,
        cns: () => 'CNS inválido',
        cnpj: () => 'CNPJ inválido',
        /* required: (susNumber) => `O campo ${susNumber} é obrigatório.`,
        required: (password) => `O campo ${password} é obrigatório.`,
        required: (Senha) => `O campo ${Senha} é obrigatório.`,
        required: (email) => `O campo ${email} é obrigatório.`,
        required: (dateOfBirth) => `O campo ${dateOfBirth} é obrigatório.`,
        required: (gender) => `O campo ${gender} é obrigatório.`,
        required: (maritalStatus) => `O campo ${maritalStatus} é obrigatório.`,
        required: (motherName) => `O campo ${motherName} é obrigatório.`,
        required: (firstName) => `O campo ${firstName} é obrigatório.`,
        email: () => 'Informe um Email válido',
        confirmed: () => 'A senha não confere' */
        
      },
    }
  }
  export default dictionary